var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('div',{staticClass:"pse-note info pse-compare"},[_c('i',{staticClass:"pi pi-eye"}),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.label))]),(_vm.hint)?[_vm._v(". "+_vm._s(_vm.hint))]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }